import { useInjectReducer } from "@app/store";
import Button from "@components/Button";
import Checkbox from "@components/Checkbox";
import InputWrapper from "@components/Input";
import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import {
  useLoadSingleFiledDataMutation,
  useSaveFieldDataMutation,
} from "@features/admin/mainFieldManage/mainFieldManageApiSlice";
import { makeSelectOne } from "@features/admin/mainFieldManage/mainFieldManageSelector";
import mainFieldManageSlice, {
  clearOne,
  setOneValue,
} from "@features/admin/mainFieldManage/mainFieldManageSlice";
import { enqueueSnackbar } from "@features/auth/authSlice";
import { APP_NAME } from "@utils/constants";
import React from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const MainFieldManageAddEdit = () => {
  useInjectReducer("mainFieldManage", mainFieldManageSlice);
  const one = useSelector(makeSelectOne);
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  //rtk
  const [loadOne, { isLoading: loading }] = useLoadSingleFiledDataMutation();
  const [saveField, { isLoading: saveLoading }] = useSaveFieldDataMutation();

  useEffect(() => {
    if (id) {
      loadOne(id);
    } else {
      dispatch(clearOne());
    }
  }, [id]);

  const handleChange = (name) => (e) => {
    dispatch(setOneValue({ key: name, value: e.target.value }));
  };

  const handleChangeChecked = (name) => (e) => {
    dispatch(setOneValue({ key: name, value: e.target.checked }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "." || e.key === ",") {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    if (paste.includes(".") || paste.includes(",")) {
      e.preventDefault();
    }
  };

  const handleSave = () => {
    saveField(one)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              message: res?.msg ?? "Field  Saved.",
              options: { variant: "success" },
            })
          );
          navigate("/admin/scheme-manage/main-field");
        }
      })
      .catch((err) => {
        dispatch(
          enqueueSnackbar({
            message: err?.data?.msg ?? "Field Save Failed.",
            options: {
              variant: "warning",
            },
          })
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>
          {id
            ? `Edit Field Name |  ${APP_NAME} `
            : `Add Field Name |  ${APP_NAME} `}
        </title>
      </Helmet>
      <PageHeader
        isBack
        handleGoBack={() => navigate(`/admin/scheme-manage/main-field`)}
        title={!id ? "Add Field Name" : "Edit Field Name"}
      />
      <PageContent>
        <div className='p-4'>
          <InputWrapper
            label={
              <>
                Field Name{" "}
                <span className='text-gray-400 text-xs'>
                  (Don't use (.) or (,) in Field Name)
                </span>
              </>
            }
            name='name'
            type='text'
            value={one?.name ?? ""}
            onChange={handleChange("name")}
            onKeyPress={handleKeyPress}
            onPaste={handlePaste}
          />
          <div>
            <Checkbox
              label='Is Active'
              checked={one?.is_active ?? false}
              name='is_active'
              onChange={handleChangeChecked("is_active")}
            />
          </div>
          <Button className='mt-4' loading={saveLoading} onClick={handleSave}>
            Save
          </Button>
        </div>
      </PageContent>
    </>
  );
};

export default MainFieldManageAddEdit;
